import script from "./Brief.vue?vue&type=script&lang=ts&setup=true"
export * from "./Brief.vue?vue&type=script&lang=ts&setup=true"

import "./Brief.vue?vue&type=style&index=0&id=94581c18&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94581c18"]])

export default __exports__